import axios from "axios";
import store, { persistor } from '../store/store';
import { clearAuthState } from "../redux/auth/authSlice";
import { clearPaidPrograms } from "../redux/auth/paidProgramSlice";

const baseURL = process.env.REACT_APP_BASE_URL; // Ensure correct env variable

// Create an Axios instance
const apiClient = axios.create({
    baseURL,
});

// Attach a response interceptor
apiClient.interceptors.response.use(
    (response) => response, // Pass valid responses through
    async (error) => {
        if (error.response) {
            const status = error.response.status;
            const dispatch = store.dispatch; // Get dispatch from Redux store

            if (status >= 400) {
                console.error("Unauthorized! Logging out...");

                // Pause, flush, and purge Redux Persist
                persistor.pause();
                await persistor.flush();
                await persistor.purge();

                // Clear localStorage and notify other tabs
                localStorage.clear();
                localStorage.setItem("logout", Date.now());

                // Dispatch logout actions
                dispatch(clearAuthState());
                dispatch(clearPaidPrograms());

                // Redirect to homepage and reload
                window.location.href = "/";
            }

            if (status >= 500) {
                console.error("Server error! Please retry later.");
            }
        }

        return Promise.reject(error); // Reject promise to maintain error handling
    }
);

export default apiClient;
